import { api } from "@/lib/api";

export const providerApi = {
    me: () => api.get("/provider/me").then((r) => r.data),
    update: (payload) => api.patch("/provider/me", payload).then((r) => r.data),

    listLocations: () => api.get("/provider/locations").then((r) => r.data.items),
    createLocation: (payload) => api.post("/provider/locations", payload).then((r) => r.data),
    updateLocation: (id, payload) => api.patch(`/provider/locations/${id}`, payload).then((r) => r.data),
    deleteLocation: (id) => api.delete(`/provider/locations/${id}`).then((r) => r.data),

    listStaff: () => api.get("/provider/staff").then((r) => r.data.items),
    createStaff: (payload) => api.post("/provider/staff", payload).then((r) => r.data),
    updateStaff: (id, payload) => api.patch(`/provider/staff/${id}`, payload).then((r) => r.data),
    deleteStaff: (id) => api.delete(`/provider/staff/${id}`).then((r) => r.data),
};

export const publicAuthApi = {
    signup: (payload) => api.post("/auth/signup", payload).then((r) => r.data),
};
